import {Injectable} from '@angular/core';
import {Observable, of, Subject} from "rxjs";
import {
  AddSurveyResponseModel,
  CreateSurveyScheduleDetails,
  EditSurveyScheduleDetails,
  FetchEditSurveyQuestionnairesResponseModel,
  FetchEditSurveySummaryDetailsResponseModel,
  FetchManageSurveyListResponse,
  FetchMyQuestionnairesDetailsModel,
  FetchMyQuestionnairesListModel,
  FetchQuestionnairesListModel,
  FetchReviewSurveyDetails,
  FetchScheduleAccordingToList,
  FetchSendToFiltersResponseModel,
  FetchSessionListForCreateSurvey,
  FetchSurveyDetailsByIdModel,
  FetchSurveyForDuplicateDetails
} from "../models/fetch-questionnaires-list.model";
import {CommonService} from "../../../shared/services/common.service";
import {v1URL} from "../../../shared/constants/urls.constants";

@Injectable({
  providedIn: 'root',
})

export class QuestionnairesService {
  updateSurveyReviewMode: Subject<'view' | 'edit'> = new Subject();

  constructor(private commonService: CommonService) {
  }

  fetchQuestionnairesList(): Observable<FetchQuestionnairesListModel['response']> {
    // const urlConfig = v1URL.user.password.set
    // return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Questionnaire List Fetched Successfully',
      data: [
        {
          id: 1,
          questionnaireId: 1,
          heading: 'Questionnaire 1',
          subHeading: 'Jan 1, 2023',
        },
        {
          id: 2,
          questionnaireId: 2,
          heading: 'Questionnaire 2',
          subHeading: 'Jan 7, 2023',
        },
        {
          id: 3,
          questionnaireId: 3,
          heading: 'Questionnaire 3',
          subHeading: 'Jan 14, 2023',
        },
        {
          id: 4,
          questionnaireId: 4,
          heading: 'Questionnaire 4',
          subHeading: 'Jan 21, 2023',
        },
      ]
    })
  }

  fetchMyQuestionnaires(payload: { pageNumber?: number, searchText?: string, sortColumn?: string, sortOrder?: number }): Observable<FetchMyQuestionnairesListModel['response']> {
    const urlConfig = v1URL.survey.myQuestionnaires;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }

  fetchMyQuestionnaireDetail(): Observable<FetchMyQuestionnairesDetailsModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Questionnaire List Fetched Successfully',
      data: {
        title: 'Welcome to Survey 2',
        descriptions: 'Information notification message goes here. Information notification\n message goes here. information notification message goes\n here.Information\n notification message goes here. Information notification message goes\n here. information notification message goes here.',
        formData: [
          {
            "type": "text",
            "name": "question1",
            "title": "First Name"
          },
          {
            "type": "text",
            "name": "question2",
            "startWithNewLine": false,
            "title": "Last Name"
          },
          {
            "type": "dropdown",
            "name": "question3",
            "title": "Are you in a shared office?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          },
          {
            "type": "dropdown",
            "name": "question5",
            "title": "Do you review physical and environmental risks?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          },
          {
            "type": "dropdown",
            "name": "question4",
            "title": "Is your network equipment physically secured?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          },
          {
            "type": "dropdown",
            "name": "question6",
            "title": "Does your information security and privacy program cover all operations, services, and systems that process sensitive data?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          }
        ]
      }
    })
  }

  fetchSurveyReviewDetails(payload: { surveyId: string }): Observable<FetchReviewSurveyDetails['response']> {
    const urlConfig = v1URL.survey.surveyResponseReview;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.surveyId));
  }

  fetchEditSurveyQuestionnaireDetails(): Observable<FetchEditSurveyQuestionnairesResponseModel['response']> {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Questionnaire Details Fetched Successfully',
      data: {
        name: '',
        elements: [
          {
            "type": "text",
            "name": "question1",
            "title": "First Name"
          },
          {
            "type": "text",
            "name": "question2",
            "startWithNewLine": false,
            "title": "Last Name"
          },
          {
            "type": "dropdown",
            "name": "question3",
            "title": "Are you in a shared office?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          },
          {
            "type": "dropdown",
            "name": "question5",
            "title": "Do you review physical and environmental risks?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          },
          {
            "type": "dropdown",
            "name": "question4",
            "title": "Is your network equipment physically secured?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          },
          {
            "type": "dropdown",
            "name": "question6",
            "title": "Does your information security and privacy program cover all operations, services, and systems that process sensitive data?",
            "choices": [
              {
                "value": "Item 1",
                "text": "Yes"
              },
              {
                "value": "Item 2",
                "text": "No"
              }
            ]
          }
        ]
      }
    })
  }

  fetchEditSurveySummaryDetails(payload: { surveyId: string, searchText?: string }): Observable<FetchEditSurveySummaryDetailsResponseModel['response']> {
    const params = {
      searchText: payload.searchText
    }
    const urlConfig = v1URL.survey.summaryList;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.surveyId, params));
  }

  fetchSurveyDetails(): Observable<FetchSurveyForDuplicateDetails['response']> {
    return of({
      success: true,
      code: 'Dummy Code  ABCD1234',
      message: 'Fetch Survey Details Successfully',
      data:
        {
          schedule: {
            "name":
              "test",
            "description":
              "descriptions",
            "scheduleAccordingTo":
              "Session",
            "session":
              "Session 1"
          }
          ,
          surveyForm: {
            name: '',
            elements:
              [
                {
                  "type": "text",
                  "name": "question1",
                  "title": "First Name"
                },
                {
                  "type": "text",
                  "name": "question2",
                  "startWithNewLine": false,
                  "title": "Last Name"
                },
                {
                  "type": "dropdown",
                  "name": "question3",
                  "title": "Are you in a shared office?",
                  "choices": [
                    {
                      "value": "Item 1",
                      "text": "Yes"
                    },
                    {
                      "value": "Item 2",
                      "text": "No"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "name": "question5",
                  "title": "Do you review physical and environmental risks?",
                  "choices": [
                    {
                      "value": "Item 1",
                      "text": "Yes"
                    },
                    {
                      "value": "Item 2",
                      "text": "No"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "name": "question4",
                  "title": "Is your network equipment physically secured?",
                  "choices": [
                    {
                      "value": "Item 1",
                      "text": "Yes"
                    },
                    {
                      "value": "Item 2",
                      "text": "No"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "name": "question6",
                  "title": "Does your information security and privacy program cover all operations, services, and systems that process sensitive data?",
                  "choices": [
                    {
                      "value": "Item 1",
                      "text": "Yes"
                    },
                    {
                      "value": "Item 2",
                      "text": "No"
                    }
                  ]
                }
              ]
          }
          ,
          sendTo: {
            "roles":
              [
                "Super Admin",
                "Client Admin"
              ],
            "clinics":
              [
                "Clinic 1",
                "Clinic 2"
              ],
            "groups":
              [
                "Groups 1",
                "Groups 2"
              ],
            "groupStatus":
              [
                "Active"
              ],
            "gender":
              [
                "Male"
              ],
            "unSafeZone":
              [
                "Danger Zone"
              ],
          }
        }
    })
  }

  fetchManageSurveyList(payload: { pageNumber: number, statuses?: number[], searchText?: string, groupId?: string, clientId?: string, sortColumn?: string, sortOrder?: number }): Observable<FetchManageSurveyListResponse['response']> {
    const urlConfig = v1URL.survey.manageSurveyList;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload));
  }


  fetchSessionListForCreateSurvey(): Observable<FetchSessionListForCreateSurvey['response']> {
    const urlConfig = v1URL.survey.sessionList;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchScheduleAccordingToList(): Observable<FetchScheduleAccordingToList['response']> {
    const urlConfig = v1URL.survey.scheduleAccordingToList;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  createSurveySendScheduleDetails(payload: CreateSurveyScheduleDetails['request']): Observable<CreateSurveyScheduleDetails['response']> {
    const urlConfig = v1URL.survey.createSurveySendScheduleDetails;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  editSurveyDetails(payload: EditSurveyScheduleDetails['request']): Observable<EditSurveyScheduleDetails['response']> {
    const urlConfig = v1URL.survey.editSurveyApis;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.surveyId), payload.requestPayload);
  }

  fetchRolesList(): Observable<FetchSendToFiltersResponseModel['response']> {
    const urlConfig = v1URL.filters.roles;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchClinicsList(payload: { pageNumber: number, shouldInclude?: string[],search?:string }): Observable<FetchSendToFiltersResponseModel['response']> {
    let params: string = ''
    if (payload.pageNumber) {
      params = `pageNumber=${payload.pageNumber}`
    }
    if (payload?.shouldInclude?.length > 0) {
      params = params + `&shouldInclude=${payload.shouldInclude.join('&shouldInclude=')}`
    }
    if (payload?.search) {
      params = params + `&search=${payload.search}`
    }
    const urlConfig = v1URL.survey.filters.clinics;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(params));
  }

  fetchGenderList(): Observable<FetchSendToFiltersResponseModel['response']> {
    const urlConfig = v1URL.filters.gender;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchGroupStatusList(): Observable<FetchSendToFiltersResponseModel['response']> {
    const urlConfig = v1URL.filters.groupStatus;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchGroupList(payload: { clientId?: number[], pageNumber?: number, shouldInclude?: number[], search?:string }): Observable<FetchSendToFiltersResponseModel['response']> {
    let params = '';
    if (payload.pageNumber) {
      params = `pageNumber=${payload.pageNumber}`
    }
    if (payload?.clientId?.length > 0) {
      params = params + `&clientId=${payload.clientId.join('&clientId=')}`
    }
    if (payload?.shouldInclude?.length > 0) {
      params = params + `&shouldInclude=${payload.shouldInclude.join('&shouldInclude=')}`
    }
    if (payload?.search) {
      params = params + `&search=${payload.search}`
    }
    const urlConfig = v1URL.survey.filters.groups;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(params));
  }

  fetchSurveyDetailsById(payload: FetchSurveyDetailsByIdModel['request']): Observable<FetchSurveyDetailsByIdModel['response']> {
    const urlConfig = v1URL.survey.surveyDetails;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.surveyId));
  }

  addSurveyResponse(payload: AddSurveyResponseModel['request']): Observable<AddSurveyResponseModel['response']> {
    const urlConfig = v1URL.survey.addSurveyResponse;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchSurveyReviewDetailsForReview(payload: { surveyId: string, userId: string }): Observable<FetchReviewSurveyDetails['response']> {
    const params = {
      forUserId: payload.userId
    }
    const urlConfig = v1URL.survey.surveyResponseForReviewForAdmins;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url(payload.surveyId, params));
  }

  fetchPendingSurveyCount(): Observable<{ success: boolean, data: { count: number }, message: string, code: string }> {
    const urlConfig = v1URL.survey.pendingSurveyCount;
    return this.commonService.callAPI(urlConfig.method, urlConfig.url);
  }
}

